import { Gender } from '@gyym/sdk'

export const genderOptions = [
  { label: '女性専用', value: Gender.WOMEN },
  { label: '男性専用', value: Gender.MEN },
  { label: '男女兼用', value: Gender.NONE },
]

export const genderLabels = {
  [Gender.MEN]: '男性',
  [Gender.WOMEN]: '女性',
  [Gender.NONE]: '男女兼用',
}

// プロフィール表示用の性別ラベル。施設用 genderLabels と異なり NONE は「未設定」。
export const profileGenderLabels = {
  [Gender.MEN]: '男性',
  [Gender.WOMEN]: '女性',
  [Gender.NONE]: '未設定',
}

// 国籍 (ISO 3166-1 alpha-2).
// Backend の GyymCommon\Core\Domain\ValueObject\General\Nationality と同期する。
export const nationalityLabels: Record<string, string> = {
  JP: '日本',
  AF: 'アフガニスタン',
  AL: 'アルバニア',
  DZ: 'アルジェリア',
  AS: 'アメリカ領サモア',
  AD: 'アンドラ',
  AO: 'アンゴラ',
  AI: 'アンギラ',
  AQ: '南極',
  AG: 'アンティグア・バーブーダ',
  AR: 'アルゼンチン',
  AM: 'アルメニア',
  AW: 'アルバ',
  AU: 'オーストラリア',
  AT: 'オーストリア',
  AZ: 'アゼルバイジャン',
  BS: 'バハマ',
  BH: 'バーレーン',
  BD: 'バングラデシュ',
  BB: 'バルバドス',
  BY: 'ベラルーシ',
  BE: 'ベルギー',
  BZ: 'ベリーズ',
  BJ: 'ベナン',
  BM: 'バミューダ',
  BT: 'ブータン',
  BO: 'ボリビア',
  BQ: 'ボネール、シント・ユースタティウスおよびサバ',
  BA: 'ボスニア・ヘルツェゴビナ',
  BW: 'ボツワナ',
  BV: 'ブーベ島',
  BR: 'ブラジル',
  IO: 'イギリス領インド洋地域',
  BN: 'ブルネイ',
  BG: 'ブルガリア',
  BF: 'ブルキナファソ',
  BI: 'ブルンジ',
  CV: 'カーボベルデ',
  KH: 'カンボジア',
  CM: 'カメルーン',
  CA: 'カナダ',
  KY: 'ケイマン諸島',
  CF: '中央アフリカ共和国',
  TD: 'チャド',
  CL: 'チリ',
  CN: '中国',
  CX: 'クリスマス島',
  CC: 'ココス諸島',
  CO: 'コロンビア',
  KM: 'コモロ',
  CD: 'コンゴ民主共和国',
  CG: 'コンゴ共和国',
  CK: 'クック諸島',
  CR: 'コスタリカ',
  CI: 'コートジボワール',
  HR: 'クロアチア',
  CU: 'キューバ',
  CW: 'キュラソー',
  CY: 'キプロス',
  CZ: 'チェコ',
  DK: 'デンマーク',
  DJ: 'ジブチ',
  DM: 'ドミニカ国',
  DO: 'ドミニカ共和国',
  EC: 'エクアドル',
  EG: 'エジプト',
  SV: 'エルサルバドル',
  GQ: '赤道ギニア',
  ER: 'エリトリア',
  EE: 'エストニア',
  SZ: 'エスワティニ',
  ET: 'エチオピア',
  FK: 'フォークランド諸島',
  FO: 'フェロー諸島',
  FJ: 'フィジー',
  FI: 'フィンランド',
  FR: 'フランス',
  GF: 'フランス領ギアナ',
  PF: 'フランス領ポリネシア',
  TF: 'フランス領南方・南極地域',
  GA: 'ガボン',
  GM: 'ガンビア',
  GE: 'ジョージア',
  DE: 'ドイツ',
  GH: 'ガーナ',
  GI: 'ジブラルタル',
  GR: 'ギリシャ',
  GL: 'グリーンランド',
  GD: 'グレナダ',
  GP: 'グアドループ',
  GU: 'グアム',
  GT: 'グアテマラ',
  GG: 'ガーンジー',
  GN: 'ギニア',
  GW: 'ギニアビサウ',
  GY: 'ガイアナ',
  HT: 'ハイチ',
  HM: 'ハード島とマクドナルド諸島',
  VA: 'バチカン',
  HN: 'ホンジュラス',
  HK: '香港',
  HU: 'ハンガリー',
  IS: 'アイスランド',
  IN: 'インド',
  ID: 'インドネシア',
  IR: 'イラン',
  IQ: 'イラク',
  IE: 'アイルランド',
  IM: 'マン島',
  IL: 'イスラエル',
  IT: 'イタリア',
  JM: 'ジャマイカ',
  JE: 'ジャージー',
  JO: 'ヨルダン',
  KZ: 'カザフスタン',
  KE: 'ケニア',
  KI: 'キリバス',
  KP: '北朝鮮',
  KR: '韓国',
  KW: 'クウェート',
  KG: 'キルギス',
  LA: 'ラオス',
  LV: 'ラトビア',
  LB: 'レバノン',
  LS: 'レソト',
  LR: 'リベリア',
  LY: 'リビア',
  LI: 'リヒテンシュタイン',
  LT: 'リトアニア',
  LU: 'ルクセンブルク',
  MO: 'マカオ',
  MG: 'マダガスカル',
  MW: 'マラウイ',
  MY: 'マレーシア',
  MV: 'モルディブ',
  ML: 'マリ',
  MT: 'マルタ',
  MH: 'マーシャル諸島',
  MQ: 'マルティニーク',
  MR: 'モーリタニア',
  MU: 'モーリシャス',
  YT: 'マヨット',
  MX: 'メキシコ',
  FM: 'ミクロネシア連邦',
  MD: 'モルドバ',
  MC: 'モナコ',
  MN: 'モンゴル',
  ME: 'モンテネグロ',
  MS: 'モントセラト',
  MA: 'モロッコ',
  MZ: 'モザンビーク',
  MM: 'ミャンマー',
  NA: 'ナミビア',
  NR: 'ナウル',
  NP: 'ネパール',
  NL: 'オランダ',
  NC: 'ニューカレドニア',
  NZ: 'ニュージーランド',
  NI: 'ニカラグア',
  NE: 'ニジェール',
  NG: 'ナイジェリア',
  NU: 'ニウエ',
  NF: 'ノーフォーク島',
  MK: '北マケドニア',
  MP: '北マリアナ諸島',
  NO: 'ノルウェー',
  OM: 'オマーン',
  PK: 'パキスタン',
  PW: 'パラオ',
  PS: 'パレスチナ',
  PA: 'パナマ',
  PG: 'パプアニューギニア',
  PY: 'パラグアイ',
  PE: 'ペルー',
  PH: 'フィリピン',
  PN: 'ピトケアン',
  PL: 'ポーランド',
  PT: 'ポルトガル',
  PR: 'プエルトリコ',
  QA: 'カタール',
  RE: 'レユニオン',
  RO: 'ルーマニア',
  RU: 'ロシア',
  RW: 'ルワンダ',
  BL: 'サン・バルテルミー',
  SH: 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
  KN: 'セントクリストファー・ネイビス',
  LC: 'セントルシア',
  MF: 'サン・マルタン (フランス領)',
  PM: 'サンピエール島・ミクロン島',
  VC: 'セントビンセントおよびグレナディーン諸島',
  WS: 'サモア',
  SM: 'サンマリノ',
  ST: 'サントメ・プリンシペ',
  SA: 'サウジアラビア',
  SN: 'セネガル',
  RS: 'セルビア',
  SC: 'セーシェル',
  SL: 'シエラレオネ',
  SG: 'シンガポール',
  SX: 'シント・マールテン (オランダ領)',
  SK: 'スロバキア',
  SI: 'スロベニア',
  SB: 'ソロモン諸島',
  SO: 'ソマリア',
  ZA: '南アフリカ',
  GS: 'サウスジョージア・サウスサンドウィッチ諸島',
  SS: '南スーダン',
  ES: 'スペイン',
  LK: 'スリランカ',
  SD: 'スーダン',
  SR: 'スリナム',
  SJ: 'スヴァールバル諸島およびヤンマイエン島',
  SE: 'スウェーデン',
  CH: 'スイス',
  SY: 'シリア',
  TW: '台湾',
  TJ: 'タジキスタン',
  TZ: 'タンザニア',
  TH: 'タイ',
  TL: '東ティモール',
  TG: 'トーゴ',
  TK: 'トケラウ',
  TO: 'トンガ',
  TT: 'トリニダード・トバゴ',
  TN: 'チュニジア',
  TR: 'トルコ',
  TM: 'トルクメニスタン',
  TC: 'タークス・カイコス諸島',
  TV: 'ツバル',
  UG: 'ウガンダ',
  UA: 'ウクライナ',
  AE: 'アラブ首長国連邦',
  GB: 'イギリス',
  US: 'アメリカ合衆国',
  UM: '合衆国領有小離島',
  UY: 'ウルグアイ',
  UZ: 'ウズベキスタン',
  VU: 'バヌアツ',
  VE: 'ベネズエラ',
  VN: 'ベトナム',
  VG: 'イギリス領ヴァージン諸島',
  VI: 'アメリカ領ヴァージン諸島',
  WF: 'ウォリス・フツナ',
  EH: '西サハラ',
  YE: 'イエメン',
  ZM: 'ザンビア',
  ZW: 'ジンバブエ',
}

export const nationalityCodes = Object.keys(nationalityLabels) as [
  string,
  ...string[],
]

/**
 * インクリメンタル検索用の追加キーワード。
 * - 漢字ラベル ("日本") を「に」「にほん」「japan」などでも引けるようにする。
 * - 英語名 (国際的に通じる表記) でも引けるようにする。
 * 正規化 (NFKC + lowercase + ひらがな→カタカナ) は SearchableSelectField 側で行うので
 * ここでは素直な綴りで OK。
 */
const nationalityKeywords: { [code: string]: string[] } = {
  // --- 漢字ラベル: 読みを必ず追加 ---
  JP: ['にほん', 'にっぽん', 'japan', 'nihon', 'nippon'],
  AQ: ['なんきょく', 'antarctica'],
  AS: ['アメリカりょうサモア', 'american samoa'],
  BV: ['ブーベとう', 'bouvet'],
  CF: ['ちゅうおうアフリカきょうわこく', 'central african'],
  CN: ['ちゅうごく', 'china'],
  CX: ['クリスマスとう', 'christmas island'],
  CC: ['ココスしょとう', 'キーリングしょとう', 'cocos', 'keeling'],
  CD: ['コンゴみんしゅきょうわこく', 'drc', 'democratic republic of the congo'],
  CG: ['コンゴきょうわこく', 'congo', 'republic of the congo'],
  CK: ['クックしょとう', 'cook islands'],
  DM: ['ドミニカこく', 'dominica'],
  DO: ['ドミニカきょうわこく', 'dominican republic'],
  EH: ['にしサハラ', 'western sahara'],
  FK: ['フォークランドしょとう', 'falkland'],
  FO: ['フェローしょとう', 'faroe'],
  GF: ['フランスりょうギアナ', 'french guiana'],
  GS: ['サウスジョージア', 'サウスサンドウィッチしょとう', 'south georgia'],
  GQ: ['せきどうギニア', 'equatorial guinea'],
  HK: ['ほんこん', 'hong kong'],
  HM: ['ハードとう', 'マクドナルドしょとう', 'heard', 'mcdonald islands'],
  IM: ['マンとう', 'isle of man'],
  IO: ['イギリスりょうインドよう', 'british indian ocean', 'biot'],
  KP: ['きたちょうせん', 'ちょうせん', 'north korea', 'dprk'],
  KR: ['かんこく', 'だいかんみんこく', 'south korea', 'korea', 'rok'],
  KY: ['ケイマンしょとう', 'cayman'],
  MF: ['サンマルタン', 'saint martin'],
  MH: ['マーシャルしょとう', 'marshall islands'],
  MK: ['きたマケドニア', 'north macedonia', 'macedonia'],
  MP: ['きたマリアナしょとう', 'northern mariana'],
  NF: ['ノーフォークとう', 'norfolk island'],
  PF: ['フランスりょうポリネシア', 'french polynesia', 'tahiti'],
  PM: ['サンピエールしま', 'ミクロンしま', 'saint pierre and miquelon'],
  SB: ['ソロモンしょとう', 'solomon islands'],
  SH: [
    'セントヘレナ',
    'アセンション',
    'トリスタンダクーニャ',
    'saint helena',
    'ascension',
    'tristan da cunha',
  ],
  SJ: ['スヴァールバルしょとう', 'ヤンマイエンとう', 'svalbard', 'jan mayen'],
  SS: ['みなみスーダン', 'south sudan'],
  SX: ['シントマールテン', 'sint maarten'],
  TC: ['タークスカイコスしょとう', 'turks and caicos'],
  TF: ['フランスりょうなんぽうなんきょくちいき', 'french southern'],
  TL: ['ひがしティモール', 'east timor', 'timor leste', 'timor-leste'],
  TW: ['たいわん', 'taiwan', 'roc'],
  UM: [
    'がっしゅうこくりょうゆうしょうりとう',
    'us minor outlying islands',
    'usmoi',
  ],
  US: [
    'アメリカがっしゅうこく',
    'beikoku',
    'america',
    'usa',
    'united states',
    'us',
  ],
  VA: ['ばちかん', 'vatican', 'holy see'],
  VC: [
    'セントビンセント',
    'グレナディーンしょとう',
    'saint vincent',
    'grenadines',
  ],
  VG: ['イギリスりょうヴァージンしょとう', 'british virgin islands'],
  VI: ['アメリカりょうヴァージンしょとう', 'us virgin islands'],
  ZA: ['みなみアフリカ', 'south africa'],
  FM: ['ミクロネシアれんぽう', 'micronesia'],
  AE: ['アラブしゅちょうこくれんぽう', 'uae', 'united arab emirates'],

  // --- カタカナラベル: 英語/別名検索のため keyword 追加 ---
  AF: ['afghanistan'],
  AL: ['albania'],
  DZ: ['algeria'],
  AD: ['andorra'],
  AO: ['angola'],
  AI: ['anguilla'],
  AG: ['antigua', 'barbuda'],
  AR: ['argentina'],
  AM: ['armenia'],
  AW: ['aruba'],
  AU: ['australia'],
  AT: ['austria'],
  AZ: ['azerbaijan'],
  BS: ['bahamas'],
  BH: ['bahrain'],
  BD: ['bangladesh'],
  BB: ['barbados'],
  BY: ['belarus'],
  BE: ['belgium'],
  BZ: ['belize'],
  BJ: ['benin'],
  BM: ['bermuda'],
  BT: ['bhutan'],
  BO: ['bolivia'],
  BQ: [
    'ボネール',
    'シントユースタティウス',
    'サバ',
    'bonaire',
    'caribbean netherlands',
  ],
  BA: ['bosnia', 'herzegovina'],
  BW: ['botswana'],
  BR: ['brazil'],
  BN: ['brunei'],
  BG: ['bulgaria'],
  BF: ['burkina faso'],
  BI: ['burundi'],
  CV: ['cabo verde', 'cape verde'],
  KH: ['cambodia'],
  CM: ['cameroon'],
  CA: ['canada'],
  TD: ['chad'],
  CL: ['chile'],
  CO: ['colombia'],
  KM: ['comoros'],
  CR: ['costa rica'],
  CI: ['cote divoire', 'ivory coast'],
  HR: ['croatia'],
  CU: ['cuba'],
  CW: ['curacao'],
  CY: ['cyprus'],
  CZ: ['czech', 'czechia'],
  DK: ['denmark'],
  DJ: ['djibouti'],
  EC: ['ecuador'],
  EG: ['egypt'],
  SV: ['el salvador'],
  ER: ['eritrea'],
  EE: ['estonia'],
  SZ: ['eswatini', 'swaziland'],
  ET: ['ethiopia'],
  FJ: ['fiji'],
  FI: ['finland'],
  FR: ['france'],
  GA: ['gabon'],
  GM: ['gambia'],
  GE: ['georgia'],
  DE: ['germany'],
  GH: ['ghana'],
  GI: ['gibraltar'],
  GR: ['greece'],
  GL: ['greenland'],
  GD: ['grenada'],
  GP: ['guadeloupe'],
  GU: ['guam'],
  GT: ['guatemala'],
  GG: ['guernsey'],
  GN: ['guinea'],
  GW: ['guinea bissau'],
  GY: ['guyana'],
  HT: ['haiti'],
  HN: ['honduras'],
  HU: ['hungary'],
  IS: ['iceland'],
  IN: ['india'],
  ID: ['indonesia'],
  IR: ['iran'],
  IQ: ['iraq'],
  IE: ['ireland'],
  IL: ['israel'],
  IT: ['italy'],
  JM: ['jamaica'],
  JE: ['jersey'],
  JO: ['jordan'],
  KZ: ['kazakhstan'],
  KE: ['kenya'],
  KI: ['kiribati'],
  KW: ['kuwait'],
  KG: ['kyrgyzstan'],
  LA: ['laos'],
  LV: ['latvia'],
  LB: ['lebanon'],
  LS: ['lesotho'],
  LR: ['liberia'],
  LY: ['libya'],
  LI: ['liechtenstein'],
  LT: ['lithuania'],
  LU: ['luxembourg'],
  MO: ['macao', 'macau'],
  MG: ['madagascar'],
  MW: ['malawi'],
  MY: ['malaysia'],
  MV: ['maldives'],
  ML: ['mali'],
  MT: ['malta'],
  MQ: ['martinique'],
  MR: ['mauritania'],
  MU: ['mauritius'],
  YT: ['mayotte'],
  MX: ['mexico'],
  MD: ['moldova'],
  MC: ['monaco'],
  MN: ['mongolia'],
  ME: ['montenegro'],
  MS: ['montserrat'],
  MA: ['morocco'],
  MZ: ['mozambique'],
  MM: ['myanmar', 'burma'],
  NA: ['namibia'],
  NR: ['nauru'],
  NP: ['nepal'],
  NL: ['netherlands', 'holland'],
  NC: ['new caledonia'],
  NZ: ['new zealand'],
  NI: ['nicaragua'],
  NE: ['niger'],
  NG: ['nigeria'],
  NU: ['niue'],
  NO: ['norway'],
  OM: ['oman'],
  PK: ['pakistan'],
  PW: ['palau'],
  PS: ['palestine'],
  PA: ['panama'],
  PG: ['papua new guinea'],
  PY: ['paraguay'],
  PE: ['peru'],
  PH: ['philippines'],
  PN: ['pitcairn'],
  PL: ['poland'],
  PT: ['portugal'],
  PR: ['puerto rico'],
  QA: ['qatar'],
  RE: ['reunion'],
  RO: ['romania'],
  RU: ['russia'],
  RW: ['rwanda'],
  BL: ['saint barthelemy', 'st barts'],
  KN: ['saint kitts and nevis'],
  LC: ['saint lucia'],
  WS: ['samoa'],
  SM: ['san marino'],
  ST: ['sao tome and principe'],
  SA: ['saudi arabia'],
  SN: ['senegal'],
  RS: ['serbia'],
  SC: ['seychelles'],
  SL: ['sierra leone'],
  SG: ['singapore'],
  SK: ['slovakia'],
  SI: ['slovenia'],
  SO: ['somalia'],
  ES: ['spain'],
  LK: ['sri lanka'],
  SD: ['sudan'],
  SR: ['suriname'],
  SE: ['sweden'],
  CH: ['switzerland'],
  SY: ['syria'],
  TJ: ['tajikistan'],
  TZ: ['tanzania'],
  TH: ['thailand'],
  TG: ['togo'],
  TK: ['tokelau'],
  TO: ['tonga'],
  TT: ['trinidad and tobago'],
  TN: ['tunisia'],
  TR: ['turkey', 'turkiye'],
  TM: ['turkmenistan'],
  TV: ['tuvalu'],
  UG: ['uganda'],
  UA: ['ukraine'],
  GB: ['england', 'britain', 'uk', 'united kingdom', 'great britain'],
  UY: ['uruguay'],
  UZ: ['uzbekistan'],
  VU: ['vanuatu'],
  VE: ['venezuela'],
  VN: ['vietnam'],
  WF: ['wallis', 'futuna'],
  YE: ['yemen'],
  ZM: ['zambia'],
  ZW: ['zimbabwe'],
}

// ドロップダウン用: 日本を先頭、その他は日本語ラベルの 50 音順 (nationalityLabels の定義順をそのまま使う)
export const nationalityOptions = [
  {
    label: '日本',
    value: 'JP',
    keywords: nationalityKeywords.JP,
  },
  ...Object.entries(nationalityLabels)
    .filter(([code]) => code !== 'JP')
    .map(([value, label]) => ({
      label,
      value,
      keywords: nationalityKeywords[value],
    })),
]
